// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-group[data-v-67816c08]{display:flex;gap:10px}", "",{"version":3,"sources":["webpack://src/components/modals/LinkButtonModal.vue"],"names":[],"mappings":"AAAA,+BAA+B,YAAY,CAAC,QAAQ","sourcesContent":[".button-group[data-v-67816c08]{display:flex;gap:10px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
